module.exports = __webpack_public_path__ + "static/pokoj-nr5-photo04-nikon-58a975a39f5cc14d7d946a2e84e777b3.jpg";